/**
 * SICH PDP — Loro Piana style
 * ============================================================================
 * Single-page interactivity for the product detail page:
 *  - Tejido (color) swatch click → switch variant + filter gallery images.
 *  - Size button click → switch variant within the current tejido.
 *  - Out-of-stock tejido → swatch shown with a strike, label “Coming Soon”.
 *  - Out-of-stock size → button shown striked, disabled.
 *  - Read more → opens “Product details” accordion + scrolls.
 *  - Size guide → opens slide-in modal.
 *  - Form submit → AJAX POST /cart/add.js, updates Prestige cart-count/dot.
 *  - Zoom: click “+” on any image → fullscreen modal with vertical thumbs.
 *
 * The script is idempotent: it bails out if already initialized.
 * ============================================================================
 */
(function () {
  'use strict';

  if (window.__sichPdpInitialized) return;
  window.__sichPdpInitialized = true;

  function handleize(str) {
    return String(str || '')
      .toLowerCase()
      .replace(/[áàäâã]/g, 'a')
      .replace(/[éèëê]/g, 'e')
      .replace(/[íìïî]/g, 'i')
      .replace(/[óòöôõ]/g, 'o')
      .replace(/[úùüû]/g, 'u')
      .replace(/[ñ]/g, 'n')
      .replace(/[ç]/g, 'c')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function formatPriceCents(cents) {
    if (cents == null) return '';
    var amount = Math.round(cents / 100);
    var withSeparators = String(amount).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '$' + withSeparators;
  }

  function initPdp() {
    var root = document.querySelector('[data-sich-pdp]');
    if (!root) return;

    var dataEl = root.querySelector('[data-sich-product-data]');
    if (!dataEl) return;

    var productData;
    try {
      productData = JSON.parse(dataEl.textContent);
    } catch (e) {
      if (window.console && console.error) console.error('SICH PDP: bad product data', e);
      return;
    }

    var state = {
      variants: productData.variants || [],
      tejidoOptionIndex: productData.tejido_option_index,
      sizeOptionIndex: productData.size_option_index,
      productComingSoon: !!productData.product_coming_soon,
      selectedVariantId: null,
      selectedTejido: null,
      selectedSize: null
    };

    function getOption(variant, idx) {
      if (idx < 0 || idx > 2) return '';
      return variant['option' + (idx + 1)] || '';
    }

    function findVariant(tejido, size) {
      var t = state.tejidoOptionIndex;
      var s = state.sizeOptionIndex;
      return state.variants.find(function (v) {
        var tejidoOk = t < 0 || tejido == null || getOption(v, t) === tejido;
        var sizeOk = s < 0 || size == null || getOption(v, s) === size;
        return tejidoOk && sizeOk;
      });
    }

    function tejidoHasStock(tejido) {
      var t = state.tejidoOptionIndex;
      if (t < 0) return state.variants.some(function (v) { return v.available; });
      return state.variants.some(function (v) {
        return getOption(v, t) === tejido && v.available;
      });
    }

    function updateUrl(variant) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      } catch (e) { /* no-op */ }
    }

    function updateVariantInput(variant) {
      var input = root.querySelector('[data-sich-variant-input]');
      if (input) input.value = variant.id;
    }

    function updatePrice(variant) {
      var el = root.querySelector('[data-sich-price]');
      if (el) el.textContent = formatPriceCents(variant.price);
    }

    function updateColorLabel() {
      var el = root.querySelector('[data-sich-color-label]');
      if (el) el.textContent = state.selectedTejido || '';
    }

    function updateSizeLabel() {
      var el = root.querySelector('[data-sich-size-label]');
      if (!el) return;
      el.textContent = state.selectedSize || el.getAttribute('data-placeholder') || 'Seleccionar';
    }

    function updateSwatchesUi() {
      var swatches = root.querySelectorAll('[data-sich-swatch]');
      var note = root.querySelector('[data-sich-coming-soon-note]');
      var anyComingSoon = false;

      swatches.forEach(function (sw) {
        var value = sw.getAttribute('data-option-value');
        var isActive = value === state.selectedTejido;
        sw.classList.toggle('is-active', isActive);
        sw.setAttribute('aria-checked', isActive ? 'true' : 'false');
        if (isActive && sw.classList.contains('sich-pdp__swatch--coming-soon')) {
          anyComingSoon = true;
        }
      });

      if (note) note.classList.toggle('is-visible', anyComingSoon);
    }

    function updateSizeButtons() {
      var btns = root.querySelectorAll('[data-sich-size-btn]');
      btns.forEach(function (btn) {
        var size = btn.getAttribute('data-option-value');
        var match = findVariant(state.selectedTejido, size);
        var available = !!(match && match.available);
        btn.style.display = match ? '' : 'none';
        btn.classList.toggle('is-active', size === state.selectedSize);
        btn.classList.toggle('is-unavailable', !available);
        btn.disabled = !available;
        if (match) btn.setAttribute('data-variant-id', match.id);
        btn.setAttribute('aria-checked', size === state.selectedSize ? 'true' : 'false');
      });
    }

    function filterGallery() {
      var slug = handleize(state.selectedTejido);
      if (!slug) return;

      var items = root.querySelectorAll('[data-sich-media-item]');
      var matchedAny = false;

      items.forEach(function (it) {
        var tags = (it.getAttribute('data-tejido-handle') || '').toLowerCase();
        if (tags && tags.indexOf(slug) !== -1) matchedAny = true;
      });

      if (matchedAny) {
        items.forEach(function (it) {
          var tags = (it.getAttribute('data-tejido-handle') || '').toLowerCase();
          var show = !!tags && tags.indexOf(slug) !== -1;
          it.style.display = show ? '' : 'none';
        });
      } else {
        var fbVariant = state.variants.find(function (v) {
          return state.tejidoOptionIndex >= 0
            && getOption(v, state.tejidoOptionIndex) === state.selectedTejido
            && v.featured_media;
        });
        var fbMediaId = fbVariant && fbVariant.featured_media ? String(fbVariant.featured_media.id) : null;

        if (fbMediaId) {
          items.forEach(function (it) {
            it.style.display = it.getAttribute('data-media-id') === fbMediaId ? '' : 'none';
          });
        } else {
          items.forEach(function (it) { it.style.display = ''; });
        }
      }

      // También filtrar thumbnails del zoom modal según el tejido seleccionado.
      var zoomThumbs = root.querySelectorAll('.sich-pdp__zoom-thumb-li');
      var anyZoomMatch = false;
      zoomThumbs.forEach(function (li) {
        var tags = (li.getAttribute('data-tejido-handle') || '').toLowerCase();
        if (tags && tags.indexOf(slug) !== -1) anyZoomMatch = true;
      });
      zoomThumbs.forEach(function (li) {
        var tags = (li.getAttribute('data-tejido-handle') || '').toLowerCase();
        if (anyZoomMatch) {
          li.style.display = (tags && tags.indexOf(slug) !== -1) ? '' : 'none';
        } else {
          li.style.display = '';
        }
      });
    }

    function updateCta(variant) {
      var btn = root.querySelector('[data-sich-add-to-cart]');
      if (!btn) return;

      var hasStock = tejidoHasStock(state.selectedTejido);
      var variantAvailable = !!(variant && variant.available);

      btn.classList.remove('is-coming-soon');
      btn.classList.remove('is-loading');
      btn.classList.remove('is-success');
      btn.classList.remove('is-error');

      if (state.productComingSoon || !hasStock) {
        btn.disabled = true;
        btn.textContent = 'Coming Soon';
        btn.classList.add('is-coming-soon');
      } else if (!variantAvailable) {
        btn.disabled = true;
        btn.textContent = 'Sin stock';
      } else {
        btn.disabled = false;
        btn.textContent = 'Agregar al carrito';
      }
    }

    function setSelectedVariant(variant) {
      if (!variant) return;
      state.selectedVariantId = variant.id;
      state.selectedTejido = state.tejidoOptionIndex >= 0 ? getOption(variant, state.tejidoOptionIndex) : null;
      state.selectedSize = state.sizeOptionIndex >= 0 ? getOption(variant, state.sizeOptionIndex) : null;

      updateUrl(variant);
      updateVariantInput(variant);
      updatePrice(variant);
      updateSwatchesUi();
      filterGallery();
      updateSizeButtons();
      updateCta(variant);
      updateColorLabel();
      updateSizeLabel();
    }

    var urlParams = new URLSearchParams(window.location.search);
    var urlVariantId = urlParams.get('variant');
    var initial = null;
    if (urlVariantId) {
      initial = state.variants.find(function (v) { return String(v.id) === urlVariantId; });
    }
    if (!initial) {
      initial = state.variants.find(function (v) { return v.available; }) || state.variants[0];
    }
    if (initial) setSelectedVariant(initial);

    /* ---- ZOOM modal logic --------------------------------------------- */
    var zoom = root.querySelector('[data-sich-zoom]');
    var zoomImg = root.querySelector('[data-sich-zoom-img]');
    var zoomCurrentIndex = 0;

    function getVisibleZoomThumbs() {
      return Array.from(root.querySelectorAll('[data-sich-zoom-thumb]'))
        .filter(function (btn) {
          var li = btn.closest('.sich-pdp__zoom-thumb-li');
          return !li || li.style.display !== 'none';
        });
    }

    function getMediaItemByIndex(idx) {
      return root.querySelector('[data-sich-media-item][data-media-index="' + idx + '"]');
    }

    function setZoomImage(idx) {
      if (!zoom || !zoomImg) return;
      var item = getMediaItemByIndex(idx);
      if (!item) return;
      var img = item.querySelector('img');
      var src = item.getAttribute('data-zoom-src')
             || (img && (img.currentSrc || img.src))
             || '';
      var alt = (img && img.alt) || '';
      zoomImg.src = src;
      zoomImg.alt = alt;
      zoomCurrentIndex = idx;
      root.querySelectorAll('[data-sich-zoom-thumb]').forEach(function (t) {
        var i = parseInt(t.getAttribute('data-zoom-index'), 10);
        t.classList.toggle('is-active', i === idx);
      });
      var activeThumb = root.querySelector('[data-sich-zoom-thumb].is-active');
      if (activeThumb && activeThumb.scrollIntoView) {
        activeThumb.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }

    function openZoom(idx) {
      if (!zoom) return;
      zoom.classList.add('is-open');
      zoom.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('sich-modal-open');
      setZoomImage(idx);
    }

    function closeZoom() {
      if (!zoom) return;
      zoom.classList.remove('is-open');
      zoom.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('sich-modal-open');
    }

    function navigateZoom(direction) {
      var visibleThumbs = getVisibleZoomThumbs();
      if (visibleThumbs.length === 0) return;
      var indices = visibleThumbs.map(function (t) {
        return parseInt(t.getAttribute('data-zoom-index'), 10);
      });
      var pos = indices.indexOf(zoomCurrentIndex);
      if (pos === -1) pos = 0;
      var nextPos = (pos + direction + indices.length) % indices.length;
      setZoomImage(indices[nextPos]);
    }

    /* ---- Event delegation --------------------------------------------- */
    root.addEventListener('click', function (e) {
      var swatch = e.target.closest('[data-sich-swatch]');
      if (swatch) {
        e.preventDefault();
        var tejidoValue = swatch.getAttribute('data-option-value');
        var v = findVariant(tejidoValue, state.selectedSize);
        if (!v || !v.available) {
          var firstAvail = state.variants.find(function (vv) {
            return state.tejidoOptionIndex >= 0
              && getOption(vv, state.tejidoOptionIndex) === tejidoValue
              && vv.available;
          });
          if (firstAvail) v = firstAvail;
        }
        if (!v) {
          v = state.variants.find(function (vv) {
            return state.tejidoOptionIndex >= 0
              && getOption(vv, state.tejidoOptionIndex) === tejidoValue;
          });
        }
        if (v) setSelectedVariant(v);
        return;
      }

      var sizeBtn = e.target.closest('[data-sich-size-btn]');
      if (sizeBtn) {
        if (sizeBtn.disabled) return;
        var sizeValue = sizeBtn.getAttribute('data-option-value');
        var nv = findVariant(state.selectedTejido, sizeValue);
        if (nv) {
          setSelectedVariant(nv);
          var details = root.querySelector('[data-sich-size-selector]');
          if (details) details.open = false;
        }
        return;
      }

      var rm = e.target.closest('[data-sich-read-more]');
      if (rm) {
        e.preventDefault();
        var pd = root.querySelector('[data-sich-accordion="product-details"]');
        if (pd) {
          pd.open = true;
          setTimeout(function () {
            pd.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 50);
        }
        return;
      }

      var sgOpen = e.target.closest('[data-sich-size-guide-trigger]');
      if (sgOpen) {
        e.preventDefault();
        var modal = root.querySelector('[data-sich-size-guide-modal]');
        if (modal) {
          modal.classList.add('is-open');
          modal.setAttribute('aria-hidden', 'false');
          document.documentElement.classList.add('sich-modal-open');
        }
        return;
      }

      var sgClose = e.target.closest('[data-sich-size-guide-close]');
      if (sgClose) {
        var modal2 = root.querySelector('[data-sich-size-guide-modal]');
        if (modal2) {
          modal2.classList.remove('is-open');
          modal2.setAttribute('aria-hidden', 'true');
          document.documentElement.classList.remove('sich-modal-open');
        }
        return;
      }

      var zoomOpenBtn = e.target.closest('[data-sich-zoom-open]');
      if (zoomOpenBtn) {
        e.preventDefault();
        var idx = parseInt(zoomOpenBtn.getAttribute('data-zoom-index'), 10) || 0;
        openZoom(idx);
        return;
      }

      var zoomThumbBtn = e.target.closest('[data-sich-zoom-thumb]');
      if (zoomThumbBtn) {
        var idx2 = parseInt(zoomThumbBtn.getAttribute('data-zoom-index'), 10) || 0;
        setZoomImage(idx2);
        return;
      }

      var zoomPrev = e.target.closest('[data-sich-zoom-prev]');
      if (zoomPrev) { navigateZoom(-1); return; }

      var zoomNext = e.target.closest('[data-sich-zoom-next]');
      if (zoomNext) { navigateZoom(1); return; }

      var zoomCloseBtn = e.target.closest('[data-sich-zoom-close]');
      if (zoomCloseBtn) { closeZoom(); return; }
    });

    document.addEventListener('click', function (e) {
      var details = root.querySelector('[data-sich-size-selector]');
      if (!details || !details.open) return;
      if (!details.contains(e.target)) details.open = false;
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var sgModal = root.querySelector('[data-sich-size-guide-modal].is-open');
        if (sgModal) {
          sgModal.classList.remove('is-open');
          sgModal.setAttribute('aria-hidden', 'true');
          document.documentElement.classList.remove('sich-modal-open');
        }
        if (zoom && zoom.classList.contains('is-open')) {
          closeZoom();
        }
      }
      if (zoom && zoom.classList.contains('is-open')) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { navigateZoom(1); }
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { navigateZoom(-1); }
      }
    });

    function getRouteRoot() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    }

    function buildVariantUrl(variantId) {
      var rootUrl = getRouteRoot();
      return rootUrl + 'variants/' + encodeURIComponent(variantId || '');
    }

    function openCartDrawerFallback() {
      var drawer = document.getElementById('cart-drawer');
      if (drawer && typeof drawer.show === 'function') {
        drawer.show();
      } else {
        var cartTrigger = document.querySelector('[aria-controls="cart-drawer"]');
        if (cartTrigger) cartTrigger.click();
      }
    }

    var form = root.querySelector('[data-sich-product-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = root.querySelector('[data-sich-add-to-cart]');
        if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;

        if (form.checkValidity && !form.checkValidity()) {
          if (form.reportValidity) form.reportValidity();
          return;
        }

        var originalText = btn.textContent;
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.classList.add('is-loading');
        btn.textContent = 'Agregando…';

        var sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        }));

        var formData = new FormData(form);
        var variantId = formData.get('id');
        if (sectionsToBundle.length > 0) {
          formData.set('sections', sectionsToBundle.join(','));
          formData.set('sections_url', buildVariantUrl(variantId));
        }

        fetch(getRouteRoot() + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData,
          credentials: 'same-origin'
        }).then(function (res) {
          return res.json().then(function (json) {
            if (!res.ok) {
              throw new Error((json && (json.description || json.message)) || 'Error');
            }
            return json;
          });
        }).then(function (responseJson) {
          return fetch(getRouteRoot() + 'cart.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              cart.sections = responseJson.sections || {};

              btn.classList.remove('is-loading');
              btn.classList.add('is-success');
              btn.textContent = 'Agregado ✓';

              form.dispatchEvent(new CustomEvent('variant:add', {
                bubbles: true,
                detail: {
                  items: responseJson && responseJson.items ? responseJson.items : [responseJson],
                  cart: cart,
                  onSuccessDo: 'force_open_drawer'
                }
              }));

              document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
                bubbles: true,
                detail: {
                  baseEvent: 'variant:add',
                  onSuccessDo: 'force_open_drawer',
                  cart: cart
                }
              }));

              setTimeout(openCartDrawerFallback, 80);

              setTimeout(function () {
                btn.classList.remove('is-success');
                btn.disabled = false;
                btn.removeAttribute('aria-busy');
                btn.textContent = originalText;
              }, 1800);
            });
        }).catch(function (err) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-error');
          btn.textContent = (err && err.message) || 'Error';
          setTimeout(function () {
            btn.classList.remove('is-error');
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
            btn.textContent = originalText;
          }, 2400);
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdp);
  } else {
    initPdp();
  }
})();
